import { Breadcrumb } from 'antd';
import { isNull } from 'lodash';
import getConfig from 'next/config';
import React from 'react';
import { BreadcrumbWrapper } from './ExtraBreadcrumb.style';

const { publicRuntimeConfig } = getConfig();
const baseUrl = publicRuntimeConfig.baseUrl;

interface ExtraBreadcrumbProps {
  extraTitle?: string;
}
const ExtraBreadcrumb: React.FC<ExtraBreadcrumbProps> = ({ extraTitle }) => {
  const getBreadcrumb = () => {
    const objBreadcrumb = [{ name: 'Home', link: baseUrl }];
    objBreadcrumb.push({ name: extraTitle, link: null });
    return objBreadcrumb;
  };

  const listBreadcrumb = getBreadcrumb();
  return (
    <BreadcrumbWrapper>
      <Breadcrumb className="breadcrumb">
        {listBreadcrumb.map(function (v, k) {
          if (!isNull(v.link)) {
            return (
              <Breadcrumb.Item key={k} data-test={'breadcrumb-item-' + k}>
                <a href={v.link}>{v.name}</a>
              </Breadcrumb.Item>
            );
          } else {
            return (
              <Breadcrumb.Item key={k} data-test={'breadcrumb-item-' + k}>
                {v.name}
              </Breadcrumb.Item>
            );
          }
        })}
      </Breadcrumb>
    </BreadcrumbWrapper>
  );
};

export default ExtraBreadcrumb;
